import { render } from "./WelcomePage.vue?vue&type=template&id=f778e382&scoped=true"
const script = {}

import "./WelcomePage.vue?vue&type=style&index=0&id=f778e382&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f778e382"]])

export default __exports__